import React, { useState } from "react";
import styled from "styled-components";
function CustomRadioButton({ Active, title, message, onChange, value, bold = false}) {
  return (
    <OuterContainer>
      <Container>
        <FieldName bold={bold}>{title}</FieldName>
        <RadioOuterContainer>
          <RadioContainer>
            <Radio
              style={{ backgroundColor: value === true ? "#304961" : "white" }}
              onClick={() => onChange(Active ? true : value)}
            />
            <Title>Yes</Title>
          </RadioContainer>
          <RadioContainer>
            <Radio
              style={{ backgroundColor: value === false ? "#304961" : "white" }}
              onClick={() => onChange(Active ? false : value)}
            />
            <Title>No</Title>
          </RadioContainer>
        </RadioOuterContainer>
      </Container>
      {message && <Message>{message}</Message>}
    </OuterContainer>
  );
}

const OuterContainer = styled.div`
  width: 100%;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
`;
const Message = styled.div`
  color: #304961;
  font-family: "Museo Sans Cyrl";
  font-size: 12px;
  padding: 0px 20px;
  font-style: italic;
  font-weight: 300;
  line-height: 30px; /* 187.5% */
`;
const FieldName = styled.div`
  white-space: nowrap;
    justify-self: start;
  color: #304961;
  font-family: "Museo Sans Cyrl";
  font-size: 14px;
  font-style: italic;
  font-weight: 300;

  @media screen and (max-width: ${props => props.firstmeeting ? "983px" : "690px"}) {
    justify-self: start;
    padding: 20px 0px 0px 0px;
  }
`;
const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr ;
  align-items: center;
  width: 100%;

  @media screen and (max-width: ${props => props.firstmeeting ? "983px" : "690px"}) {
    grid-template-columns: 1fr;
    gap: 10px;
    max-height: 100px;
  }
`;
const Radio = styled.div`
  outline: 1px solid #5e86a5;
  width: 20px;
  height: 20px;
  border-radius: 100px;
  border: 3px solid white;
`;
const RadioContainer = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
  justify-content: center;
`;

const RadioOuterContainer = styled.div`
display: flex;
align-itmes; center;
width: 100%;
    justify-self: start;
gap: 20px;


@media screen and (max-width: 690px) {
  justify-content: start;
}

`;
const Title = styled.div`
  color: #304961;
  font-family: "Museo Sans Cyrl";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px;
`;
export default CustomRadioButton;
